import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import Table from 'react-bootstrap/lib/Table';
import FormControl from 'react-bootstrap/lib/FormControl';
import Button from 'react-bootstrap/lib/Button';
import FormGroup from 'react-bootstrap/lib/FormGroup';
import { useIntl, FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';

import Link from '../../components/Link';
import messages from '../../locale/messages';
import showToaster from '../../helpers/showToaster';
import { salesUser } from '../../helpers/DemoRestriction/demo';
import { getSpecificConfig } from '../../helpers/getConfigValue';

import ExportImage from '/public/adminIcons/export.png';

import bt from '../../components/commonStyle.css';
import s from './CommonTable.css';

function CommonTable(props) {
  const {
    title,
    handleSearch,
    tbody,
    thead,
    isSearch,
    addAction,
    redirectionLabel,
    handleFilter,
    filterOption,
    exportURL,
    linkLabel,
    isLink,
    linkURL,
    handleFilterChange,
    listFilters,
    isSearchAdd,
    loading,
    customFilters,
    customDateRangePicker,
  } = props;

  const intl = useIntl();
  const isAdmin = useSelector((state) => state.runtime.isAdminAuthenticated);
  const adminId = useSelector((state) => state?.adminPrevileges?.privileges?.id,);

  const [isDemoRestrict, setRestrict] = useState('false');

  useEffect(() => {
    async function fetchData() {
      const settingData = await getSpecificConfig({ name: ['isDemoRestricted'] });
      setRestrict(settingData?.isDemoRestricted);
    }
    fetchData();
  }, []);

  const theadData = thead();
  const tbodyData = tbody();

  const restrictExport = () => {
    showToaster({ messageId: 'disableDemo', toasterType: 'warning' })
  };

  return (
    <>
      {title && <h1 className={s.siteAdminHeading}>{title}</h1>}

      {addAction && !isSearchAdd && (
        <div className={s.space4}>
          <Button className={cx(bt.btnPrimary, bt.btnLarge)} onClick={addAction}>
            {redirectionLabel}
          </Button>
        </div>
      )}

      {(isSearch || exportURL || filterOption?.length > 0 || listFilters?.length > 0 || isSearchAdd || customFilters?.length > 0 || customDateRangePicker) && (
        <div className={s.tableTopBox}>
          <div className={s.tableTopWrapper}>
            {isSearch && (
              <div className={s.tableTopSearchFieldBox}>
                <FormControl
                  type="text"
                  placeholder={intl.formatMessage(messages.search)}
                  onChange={handleSearch}
                  className={cx('searchInputControl', 'searchInputControlAR')}
                />
              </div>
            )}

            {filterOption?.length > 0 && (
              <div className={s.tableTopSelectFieldBox}>
                <FormGroup controlId="formControlsSelect" className={s.noMargin}>
                  <FormControl
                    onChange={handleFilter}
                    componentClass="select"
                    placeholder={intl.formatMessage(messages.selectLabel)}
                    className={cx(bt.commonControlSelect, s.userSelect, 'commonControlSelectRtl')}
                  >
                    {filterOption?.map((item, index) => (
                      <option key={index} value={item?.value}>
                        {item?.label}
                      </option>
                    ))}
                  </FormControl>
                </FormGroup>
              </div>
            )}

            {listFilters?.length > 0 && (
              <div className={s.tableTopSelectFieldBox}>
                <FormGroup controlId="formControlsSelect" className={s.noMargin}>
                  <FormControl
                    onChange={(e) => handleFilterChange(Number(e.target.value))}
                    componentClass="select"
                    placeholder={intl.formatMessage(messages.selectLabel)}
                    className={cx(bt.commonControlSelect, s.userSelect, 'commonControlSelectRtl')}
                  >
                    {listFilters?.map((item, index) => (
                      <option key={index} value={item?.value}>
                        {item?.label}
                      </option>
                    ))}
                  </FormControl>
                </FormGroup>
              </div>
            )}

            {customFilters?.length > 0 && customFilters.map((filter, filterIndex) => (
              <div key={filterIndex} className={s.tableTopSelectFieldBox}>
                <FormGroup controlId={`customFilter${filterIndex}`} className={s.noMargin}>
                  <FormControl
                    onChange={filter.onChange}
                    componentClass="select"
                    value={filter.value}
                    className={cx(bt.commonControlSelect, s.userSelect, 'commonControlSelectRtl')}
                  >
                    {filter.options?.map((option, optionIndex) => (
                      <option key={optionIndex} value={option.value}>
                        {option.label}
                      </option>
                    ))}
                  </FormControl>
                </FormGroup>
              </div>
            ))}

            {customDateRangePicker && (
              <div className={s.tableTopSelectFieldBox} style={{ maxWidth: '290px' }}>
                {customDateRangePicker}
              </div>
            )}
          </div>

          {(isSearchAdd || isLink || exportURL) && <div className={s.tableBtnGrp}>
            {isSearchAdd && <div>
              <Button className={cx(bt.btnPrimary, bt.btnLarge)} onClick={addAction}>{redirectionLabel}</Button>
            </div>}
            {isLink && (
              <div>
                <Link to={linkURL} className={cx(bt.btnPrimary, bt.btnLarge)}>
                  {linkLabel}
                </Link>
              </div>
            )}
            {exportURL && (
              <div>
                {isDemoRestrict == 'true' && salesUser.indexOf(adminId) < 0 ? <a href={'#'} className={cx(s.exportText)} onClick={() => restrictExport()}>
                  <span className={s.vtrMiddle}>
                    <FormattedMessage {...messages.exportDataIntoCSV} />
                  </span>
                  <span className={s.exportLinkImg}>
                    <img src={ExportImage} className={s.exportImg} alt="Export" />
                  </span>
                </a> : <a href={exportURL} className={cx(s.exportText)}>
                  <span className={s.vtrMiddle}>
                    <FormattedMessage {...messages.exportDataIntoCSV} />
                  </span>
                  <span className={s.exportLinkImg}>
                    <img src={ExportImage} className={s.exportImg} alt="Export" />
                  </span>
                </a>}
              </div>
            )}
          </div>}
        </div>
      )}

      <div
        className={cx(
          isAdmin
            ? 'table-responsive NewAdminResponsiveTable NewResponsiveTableAdmin'
            : 'payoutTable NewResponsiveTable mobileTable',
          (isSearch || exportURL || filterOption?.length > 0 || listFilters?.length > 0 || customFilters?.length > 0) && 'noTopBorderRadius'
        )}
      >
        <Table>
          <thead>
            <tr>
              {theadData?.map((item, index) => (
                <th scope="col" key={index}>
                  {item.data}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {tbodyData?.length > 0 ? (
              tbodyData.map((item) => (
                <tr key={item?.id}>
                  {item?.data?.map((value, index) => (
                    <td data-label={theadData[index]?.data} key={index}>
                      {value?.data}
                    </td>
                  ))}
                </tr>
              ))
            ) : (!loading &&
              <tr>
                <td colSpan={theadData?.length}>
                  <FormattedMessage {...messages.noRecordFound} />
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      </div>
    </>
  );
}

export default withStyles(s, bt)(CommonTable);